/**
 * External Imports
 */
import styled from 'styled-components';

export const InputHeading = styled.div`
  display: inline-block;
  font-size: 0.9375rem;
  line-height: 22px;
  margin-top: 12px;
`;

export const StyledDivider = styled.hr`
  width: 98%;
  margin-right: 1.5rem;
`;

// TODO: Keeping to see if any styling should apply to Dropdown
// export const DropDownSearchContainer = styled.div`
//   z-index: 10;
//   overflow: scroll;
//   ::-webkit-scrollbar {
//     width: 3px;
//   }
//   ::-webkit-scrollbar-thumb {
//     background: rgb(224, 224, 224);
//     border-radius: 10px;
//   }
// `;
